module.exports = __webpack_public_path__ + "static/media/apartment10.60fe3817.jpg";